import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import {
  GroupedSessions,
  groupSessionsByDate,
} from "../../utils/dateExtensions";
import { MAX_DISPLAYED_SESSIONS } from "../constants/sessionConstants";

/**
 * Selector to get upcoming sessions from state
 */
export const selectUpcomingSessions = (state: RootState) =>
  state.sessions.upcomingSessionsState.upcomingSessions;

/**
 * Selector to get upcoming sessions loading status
 */
export const selectUpcomingSessionsStatus = (state: RootState) =>
  state.sessions.upcomingSessionsState.loadingStatus;

/**
 * Selector to get upcoming sessions initialization status
 */
export const selectUpcomingSessionsInitializationStatus = (state: RootState) =>
  state.sessions.upcomingSessionsState.initializationStatus;

/**
 * Selector to get upcoming sessions grouped by date, limited to MAX_DISPLAYED_SESSIONS sessions
 */
export const selectUpcomingSessionsGroupedByDate = createSelector(
  [selectUpcomingSessions],
  (upcomingSessions): GroupedSessions[] => {
    return groupSessionsByDate(
      upcomingSessions,
      MAX_DISPLAYED_SESSIONS, // maxSessions
      "asc" // sortOrder - earliest first for upcoming sessions
    );
  }
);

/**
 * Selector to check if there are any upcoming sessions
 */
export const selectHasUpcomingSessions = createSelector(
  [selectUpcomingSessions],
  (upcomingSessions): boolean => upcomingSessions.length > 0
);

/**
 * Selector to get the count of upcoming sessions
 */
export const selectUpcomingSessionsCount = createSelector(
  [selectUpcomingSessions],
  (upcomingSessions): number => upcomingSessions.length
);
